import type { ShippingFormFields } from "@jti/commerce-types";
import type { GetEligibleCampaignsResponseType } from "@jti/rest-api-types";

export type SectionState = "active" | "editing" | "completed" | "rested";

export enum CheckoutV2LoyaltyChoice {
  COLLECT = 0,
  REDEEM = 1,
}

export type SecuredFieldsCreditCardDetails = {
  cardBrand: string;
  maskedCardNumber: string;
};

export type SecuredFieldsPayment = {
  sessionId: string;
  paymentMethodCode: string;
  tokenize: boolean;
  cardDetails?: SecuredFieldsCreditCardDetails;
};

export type CheckoutV2Data = Partial<ShippingFormFields> & {
  securedFieldsPayment?: SecuredFieldsPayment;
};

export type CheckoutV2SectionsState = {
  shippingSection: SectionState;
  paymentSection: SectionState;
  orderConfirmationSection: SectionState;
};

export type CheckoutV2Error = {
  message: string;
  type: "server" | "validation" | "network" | "unknown";
  fieldName?: string;
};

export type CheckoutV2LoyaltyState = {
  loyaltyChoice: CheckoutV2LoyaltyChoice | undefined;
  loyaltyCampaignId: string;
  isLoyaltyError: boolean;
  loyaltyPoints?: number;
  loyaltyVoucher?: GetEligibleCampaignsResponseType;
};

export type CheckoutV2State = {
  sectionsState: CheckoutV2SectionsState;
  data: CheckoutV2Data | null;
  error: CheckoutV2Error | null;
  loyaltyPointsState: CheckoutV2LoyaltyState;
};
